<template>
  <iframe
    :src="`https://www.youtube.com/embed/${getVideoId(url)}`"
    style="width: 100%; height: 100%; border: 0;"
    allowfullscreen
  ></iframe>
</template>

<script>
export default {
  name: 'YoutubeShort',

  props: {
    url: { type: String, required: true }
  },

  methods: {
    getVideoId(url) {
      const match = url.match(/\/shorts\/([\w-]+)/);
      return match ? match[1] : '';
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
